









import {Prop} from 'vue-property-decorator';
import {Component, Vue} from '@/shared/component';

import storeLongueursVente from '@/stores/modules/longueursVente';
import InputGenericEntitySelect from './GenericEntitySelect.vue';

@Component({
	components: {
		InputGenericEntitySelect
	}
})
export default class InputLongueursVente extends Vue {

	@Prop ({ type: Function, required: false, default: () => ( () => true ) }) private itemFilter!: () => boolean;
	
	store = storeLongueursVente;
}
